module.exports = __webpack_public_path__ + "img/banner_stores_20251110.117063e6.jpg";